import React, { useContext } from "react";
import ReactModal from "react-modal";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

function ReinitParcours() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    content: {
      width: "400px",
    },
  };

  function closeModal() {
    appDispatch({ type: "CLOSE_REINIT_PARCOURS_MODAL" });
  }

  function reinitParcours() {
    appDispatch({ type: "REINIT_PARCOURS" });
  }

  ReactModal.setAppElement("#root");

  return (
    <ReactModal
      isOpen={appState.reinitParcoursModalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Réinitialiser"
      className="modal-window reinit-modal"
    >
      <button onClick={closeModal} className="modal-window__fermer">
        <span className="visually-hidden">Fermer</span>
      </button>
      <div className="modal-window__container">
        <h2>Réinitialiser le parcours</h2>
        <p>Êtes-vous certain(e) de vouloir réinitialiser le parcours&nbsp;?</p>
        <div className={"modal-window__buttons"}>
          <button
            className="btn btn-standard btn-disabled"
            onClick={closeModal}
          >
            Annuler
          </button>
          <button
            className="btn btn-standard btn-primary"
            onClick={reinitParcours}
          >
            Réinitialiser
          </button>
        </div>
      </div>
    </ReactModal>
  );
}

export default ReinitParcours;
